import { Component, inject, signal, computed } from '@angular/core';
import { RouterOutlet, RouterModule, Router, NavigationEnd } from '@angular/router';
import { ArrowIconComponent } from '../../shared/svg/arrow-icon';
import { CrustLogoComponent } from '../../shared/svg/crust-logo';
import { HeartIconComponent } from '../../shared/svg/heart-icon';
import { ExternalLinkIconComponent } from '../../shared/svg/external-link-icon';
import { AuthService } from '../../auth/service/auth';
import { filter } from 'rxjs/operators';

@Component({
	selector: 'app-app-layout',
	imports: [RouterOutlet, RouterModule, ArrowIconComponent, CrustLogoComponent, HeartIconComponent, ExternalLinkIconComponent],
	templateUrl: './app-layout.html',
	styleUrl: './app-layout.scss'
})
export class AppLayout {
	// This layout handles all non-game screens with responsive content container, nav, and footer

	public authService = inject(AuthService);
	private router = inject(Router);

	currentYear = new Date().getFullYear();

	// Track CRT class state
	crtEnabled = signal(false);

	// Track nav textShadow animation state
	navTextShadowEnabled = signal(false);

	// Track current URL to conditionally show backgrounds
	currentUrl = signal(this.router.url);

	// Computed signal to check if we're on routes that need city background
	useCityBackground = computed(() => {
		const url = this.currentUrl();
		return url.includes('/myprizes') || url.includes('/myavatar');
	});

	// Computed signal to set the height of the nature sky
	getNatureSkyHeight = computed(() => {
		const url = this.currentUrl();
		if (url.includes('/app')) {
			return '800px';
		} else if (url.includes('/auth')) {
			return '600px';
		} else {
			return '830px';
		}
	});

	constructor() {
		// Subscribe to route changes
		this.router.events
			.pipe(
				filter(event => event instanceof NavigationEnd)
			)
			.subscribe((event: NavigationEnd) => {
				this.currentUrl.set(event.url);
			});
	}

	async signOut(): Promise<void> {
		try {
			await this.authService.signOut();
		} catch (error) {
			console.error('Error signing out:', error);
		}
	}

	toggleCrt(): void {
		this.crtEnabled.update(enabled => !enabled);
		const body = document.body;
		if (this.crtEnabled()) {
			body.classList.add('crt');
		} else {
			body.classList.remove('crt');
		}
	}

	toggleNavTextShadow(): void {
		this.navTextShadowEnabled.update(enabled => !enabled);
		const body = document.body;
		if (this.navTextShadowEnabled()) {
			body.classList.add('nav-text-shadow');
		} else {
			body.classList.remove('nav-text-shadow');
		}
	}
}
